import React, { Component } from 'react';
import { TabContent, Alert, CustomInput, InputGroup, InputGroupAddon, UncontrolledTooltip, TabPane, NavItem, FormFeedback, NavLink, Spinner, Form, FormGroup, Label, Row, Col, Input, Button, Card, CardHeader, CardFooter, CardBody, CardTitle, CardText } from 'reactstrap';
import { withRouter } from 'react-router';
import _ from 'underscore';
import { Global } from '~/App'
import API from '~/API';
import GriddleCasero from '~/components/GriddleCasero'
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from 'recharts';

class Convenios extends Component {
    constructor() {
        super();
    }
    componentWillMount() {
        this.Redirect(this.props);
    }
    Redirect(props) {
        if (!this.props.Servicio.idServicio || (this.props.Convenios || []).length == 0) {
            props.history.replace("/administra")
        }
    }
    render() {
        var Convenios = this.props.Convenios;
        const columns = [
            { key: "TipoConvenio", name: "Convenio" },
            { key: "FechaConvenio", name: "Fecha Suscripción", formatter: "fecha", right: true },
            { key: "MontoConvenido", name: "Monto Convenido", right: true, formatter: "dinero" },
            { key: "MontoPie", name: "Pie", right: true, formatter: "dinero" },
            { key: "NoCuotas", name: "Cuotas", right: true, formatter: "derecha" },
            { key: "Saldo", name: "Saldo", right: true, formatter: "dinero" },
        ];
        var rows = _.sortBy(Convenios || [], d => moment(d.FechaConvenio)).reverse();
        return (
            <div>
                <Row>
                    <Col sm={12} className="bordeIzquierdo">
                        {/* Vista para escritorio y tablet */}
                        <div className="d-none d-md-block">
                            <GriddleCasero
                                data={rows}
                                columns={columns}
                            />
                        </div>

                        {/* Vista para móviles */}
                        <div className="d-md-none">
                            {rows.length > 0 ? (
                                rows.map((item, index) => (
                                    <Card key={index} className="mb-3">
                                        <CardBody>
                                            <p><i className="fa fa-handshake-o mr-2" /><strong>Convenio:</strong> {item.TipoConvenio}</p>
                                            <p><i className="fa fa-calendar mr-2" /><strong>Fecha Suscripción:</strong> {moment(item.FechaConvenio).format("DD/MM/YYYY")}</p>
                                            <p><i className="fa fa-money mr-2" /><strong>Monto Convenido:</strong> ${Global.FormatearNumero(item.MontoConvenido)}</p>
                                            <p><i className="fa fa-money mr-2" /><strong>Pie:</strong> ${Global.FormatearNumero(item.MontoPie)}</p>
                                            <p><i className="fa fa-calculator mr-2" /><strong>Cuotas:</strong> {item.NoCuotas}</p>
                                            <p><i className="fa fa-money mr-2" /><strong>Saldo:</strong> ${Global.FormatearNumero(item.Saldo)}</p>
                                        </CardBody>
                                    </Card>
                                ))
                            ) : (
                                <p className="text-center text-muted">No se encontraron convenios.</p>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}


export default withRouter(Convenios);